module.exports = __webpack_public_path__ + "img/robot_bg.67c1bae2.png";